import React from 'react'

function UnderConstruction() {
  return (
    <div>This page is under construction..</div>
  )
}

export default UnderConstruction